import { FC } from 'react';
import { NavLink } from 'react-router-dom';
import { Link } from '@chakra-ui/react';

type Props = {
  /** リンク先のパス */
  to: string;
  /** リンクの中身 */
  children: React.ReactNode;
};

export const SideNavLink: FC<Props> = ({ to, children }) => (
  <Link
    as={NavLink}
    to={to}
    display="block"
    p="0.5rem 2rem"
    w="100%"
    textDecoration="none"
    color="rgba(255, 255, 255, 0.7)"
    textAlign="start"
    fontSize="16px"
    fontWeight="bold"
    _hover={{
      opacity: '0.8',
    }}
    _focus={{
      outline: 'none',
    }}
    _activeLink={{
      color: '#fff',
      backgroundColor: '#1e1f24',
    }}
  >
    {children}
  </Link>
);
